<template>
	<div :title="channel.name">
		<SettingSwitch :title="channel.name" :isSwitchDisabled="isOn && channel.is_forced" :switchValue.sync="isOn" />
		<p v-if="isOn && channel.workspace_note">{{ channel.workspace_note }}</p>
		<p class="warning-message" v-if="showNotice">
			<IconWarning class="warning-icon" />
			For this to work, a workspace admin needs to configure a connection in <a @click="openSettings">workspace settings</a>.
		</p>
		<CompactNodeEditor v-if="node && isOn" :node="node" />
	</div>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { editedWorkflowVersion } from '@/store/modules/selectedWorkflow/getters';
import { editNode, editNodeAction, notification } from '@/store/modules/selectedNode/getters';
import { getActionParams } from '@/store/modules/actions/getters';
import { getNode } from '@/store/modules/nodes/getters';
import { getServiceBySlug } from '@/store/modules/apps/getters';
import CompactNodeEditor from '@/components/BlockEditorNotification/CompactNodeEditor';
import SettingSwitch from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/SettingSwitch';
import { account, credByServiceVersionId } from '@/store/modules/account/getters';
import IconWarning from '@/components/FlowTreeBlock/assets/icon-exclamation-unknown.svg';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'NotificationChannelConfig',
	components: {
		CompactNodeEditor,
		SettingSwitch,
		IconWarning,
	},
	props: {
		channel: { type: Object, required: true },
		channelConfig: { type: Object, required: true },
	},
	data() {
		return {
			paramsMap: null,
		};
	},
	computed: {
		...mapGettersShorthand({
			editedWorkflowVersion,
			editNodeAction,
			editNode,
			notification,
			getServiceBySlug,
			getNode,
			getActionParams,
			account,
			credByServiceVersionId,
		}),
		node() {
			return this.channelConfig.node ? this.getNode(this.channelConfig.node) : null;
		},
		cred() {
			return this.credByServiceVersionId(this.channel.service_version_id);
		},
		showNotice() {
			return this.isOn && this.channel.requires_cred && !this.cred;
		},
		isOn: {
			get() {
				return this.channelConfig.is_on;
			},
			set(val) {
				this.$emit('update:channelIsOn', val);
			},
		},
	},
	methods: {
		openSettings() {
			AppDialogManagerService.openSettingsDialog({ routeName: 'SettingsOrganization' });
		},
	},
};
</script>
